// See https://docs.djangoproject.com/en/5.1/topics/i18n/translation/ for documentation on this Django i18n API

export const gettext = (text: string) => window.gettext(text);

// i.e. "Page %s of %s" -> "Page 1 of 2" where values = [1, 2]
export const interpolate = (text: string, values: (string | number)[]) =>
  window.interpolate(text, values);
